import { NgModule } from '@angular/core';
import { AuthenticatedLayoutComponent } from './pages/authenticated-layout.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@core/material/material.module';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@core/pipes/pipes.module';

@NgModule({
    declarations: [AuthenticatedLayoutComponent],
    imports: [CommonModule, MaterialModule, RouterModule, PipesModule],
    exports: [AuthenticatedLayoutComponent, RouterModule, PipesModule],
})
export class AuthenticatedLayoutModule { }
